import { useCallback, useRef } from 'react'

import { useApolloClient } from '@apollo/client'
import {
  CompanyEmployeesCountsDocument,
  CompanyEmployeesTableDocument,
  EmployeeDetailsDocument,
  ItAssetDocumentUpdatedDocument,
} from 'generated/resources/graphql'

import { useSubscription } from 'modules/core/hooks/useSubscription'

interface UseItAssetDocumentUpdatedProps {
  employeeId?: number
}

export const useItAssetDocumentUpdated = ({ employeeId }: UseItAssetDocumentUpdatedProps = {}) => {
  const client = useApolloClient()
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null)

  const refetchData = useCallback(() => {
    client.refetchQueries({
      include: [CompanyEmployeesTableDocument, CompanyEmployeesCountsDocument],
    })

    if (employeeId) {
      client.query({
        query: EmployeeDetailsDocument,
        variables: { employeeId },
        fetchPolicy: 'network-only',
      })
    }
  }, [client, employeeId])

  useSubscription(ItAssetDocumentUpdatedDocument, {
    onData: ({ data: subscriptionData }) => {
      const document = subscriptionData.data?.itmanagementItAssetDocumentUpdate?.itAssetDocument

      if (!document) return

      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current)
      }

      debounceTimerRef.current = setTimeout(() => {
        refetchData()
      }, 100)
    },
  })
}
